<template
  ><div
    id="topNav"
    class="navbar navbar-expand-lg navbar-light shadow-sm bg-white"
  >
    <nav id="content" class="d-flex bg-white w-75 m-auto">
      <div
        class="d-flex pointer overflow-hidden"
        @click="$router.push(backRoute)"
      >
        <span
          class="font-family-base font-weight-light text-dark disable-select text-truncate"
          id="return"
        >
          <i class="long arrow alternate left icon m-0 mr-1"></i>
          {{ "components.secondNavBar.back" | i18n }}
        </span>
      </div>
      <div class="ml-auto page-name text-truncate">
        {{ pageType }}
      </div>
    </nav>
  </div>
</template>
<script>
/**
 * @description Affiche la barre de navigation secondaire permettant à l'utilisateur de se repérer dans le site
 * @author Francine Jin
 * @vue-prop {String} pageType - Le type de la page (client, logiciel, serveur...)
 * @vue-prop {String} backRoute - La page précédente
 */
export default {
  name: "NavBarSecond",
  props: {
    pageType: {
      type: String,
      required: true
    },
    backRoute: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.arrow {
  width: 18px !important;
}

#return {
  transform: translateX(-20px);
  transition: all 0.15s ease-in-out;
}
@media (min-width: 992px) {
  #return:hover {
    text-decoration: none;
    transform: translateX(0);
  }
}
.page-name {
  letter-spacing: 3px;
}
#topNav {
  border-top: 1px solid $gray-300;
  height: 56px;
  position: sticky;
  top: 56px;
  z-index: 10;
}
.vertical-bar {
  height: 2px;
  background: $gray-500;
  width: 30px;
}
@media screen and (max-width: 1025px) {
  #content {
    width: 90% !important;
  }
}
@media screen and (max-width: 414px) {
  #content {
    width: 100% !important;
    margin: auto;
  }
  #home {
    display: none;
  }
}

@media screen and (min-width: 1366px) {
  #content {
    width: 1366px;
  }
}
</style>
